import script from "./ModalProcessProgress.vue?vue&type=script&lang=ts&setup=true"
export * from "./ModalProcessProgress.vue?vue&type=script&lang=ts&setup=true"

import "./ModalProcessProgress.vue?vue&type=style&index=0&id=17da9e78&lang=scss"

const __exports__ = script;

export default __exports__